/**
 * Up-to-two-letter uppercase initials from an organization name — the fallback
 * mark for org avatars in the Raw Footage tree and the Organizations table. Pure.
 */
export function orgInitials(name: string): string {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();
}
